import { ConfirmPopup, Text } from '~/commonComponents';
import WarningIcon from '~/images/icons/Warning';
import { Colors } from '~/themes/colors';

const WarningIconComponent = () => (
  <WarningIcon width={80} height={80} color={Colors.warning_500} />
);

interface IRejectCandidateConfirmationPopupProps {
  hasScheduledInterview?: boolean;
  isLoading: boolean;
  professionalName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const RejectCandidateConfirmationPopup = ({
  hasScheduledInterview = false,
  isLoading,
  professionalName,
  onClose,
  onConfirm,
}: IRejectCandidateConfirmationPopupProps) => (
  // @ts-expect-error - ConfirmPopup still written in JavaScript
  <ConfirmPopup
    Icon={WarningIconComponent}
    title="Before You Continue"
    titleStyle={{ marginTop: 21, marginBottom: 20 }}
    description={
      hasScheduledInterview ? (
        <Text color={Colors.neutral_500}>
          This action is permanent. Once rejected,{' '}
          <Text bold color={Colors.neutral_500}>
            {professionalName}
          </Text>{' '}
          will no longer be able to apply to onsite interviews for this job. Any scheduled
          interviews will be cancelled, and the candidate will be moved to the Rejected tab on your
          Candidates page.
        </Text>
      ) : (
        <Text color={Colors.neutral_500}>
          This action is permanent. Once rejected,{' '}
          <Text bold color={Colors.neutral_500}>
            {professionalName}
          </Text>{' '}
          will no
          <br />
          longer be able to apply to onsite interviews for this job.
          <br />
          Do you want to continue?
        </Text>
      )
    }
    descriptionStyle={{ width: '100%', marginBottom: 38 }}
    modalStyle={{ width: 560 }}
    leftButtonAction={onClose}
    leftButtonDisabled={isLoading}
    leftButtonText="Go Back"
    rightButtonAction={onConfirm}
    rightButtonLoading={isLoading}
    rightButtonText="Yes, Reject"
  />
);
